<template>
  <div class="h-dialogContainer">
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit">{{$t('Pm.taskName')}}:</div>
          <input
            class="e-input"
            type="text"
            :readonly="true"
            v-model="detail.sysMeterTimelyTaskName"
            disabled="disabled"
          />
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox-topo-trunk">
        <div class="h-inputLit">{{$t('Pm.resourceType')}}:</div>
        <input class="e-input" type="text" :readonly="true" v-model="detail.neType" disabled="disabled" />
      </div>
    </div>

    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit">{{$t('Pm.measurementObjectClassify')}}:</div>
          <input class="e-input" type="text" :readonly="true" v-model="detail.counterType" disabled="disabled" />
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox-topo-trunk">
        <div class="h-inputLit">{{$t('Pm.taskEstablishTime')}}:</div>
        <input class="e-input" type="text" :readonly="true" v-model="detail.alarmCreateTime" disabled="disabled" />
      </div>
    </div>

    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit">{{$t('Pm.samplingPeriod_unit')}}:</div>
          <input class="e-input" type="text" :readonly="true" v-model="detail.sysMeterTimelyCycle" disabled="disabled" />
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox-topo-trunk">
        <div class="h-inputLit">{{$t('Pm.taskDuration')}}:</div>
        <input
          class="e-input"
          type="text"
          :readonly="true"
          v-model="detail.sysMeterTimelyTimeQuant"
          disabled="disabled"
        />
      </div>
    </div>

    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit">{{$t('Pm.saveDataOrNot')}}:</div>
          <ejs-radiobutton
            ref="saveFileRadio"
            :label='$t("Pm.yes")'
            name="saveFile"
            value="1"
            :disabled="true"
          ></ejs-radiobutton>
          <ejs-radiobutton :label='$t("Pm.no")' name="saveFile" value="0" checked="true" :disabled="false"></ejs-radiobutton>
        </div>
      </div>
    </div>

    <div class="h-pm-trunk">
      <div class="h-pm-trunka">
        <div>
          <ejs-treeview
            id="detailSeatTree"
            ref="detailSeatTree"
            :fields="fields"
            :showCheckBox="true"
            :autoCheck="false"
            :disabled="true"
          ></ejs-treeview>
        </div>
      </div>
      <div class="h-pm-trunkd"></div>

      <div class="h-pm-trunkc">
        <div>
          <!-- 测量指标 -->
          <ejs-treeview
            id="detailIndicatorTree"
            ref="detailIndicatorTree"
            :fields="indicatorFields"
            :showCheckBox="true"
            :disabled="true"
          ></ejs-treeview>
        </div>
      </div>
    </div>

    <div class="h-clear-rowMg"></div>
  </div>
</template>

<script>

import commonUtil from './commonUtil';

class Detail {
  constructor() {
    this.sysMeterTimelyTaskName = undefined;
    this.neType = undefined;
    this.counterType = undefined;
    this.alarmCreateTime = undefined;
    this.sysMeterTimelyCycle = undefined;
    this.sysMeterTimelyTimeQuant = undefined;
    this.filesSwitch = undefined;
    this.neVersionId = undefined;
    this.neTypeId = undefined;
  }
}

class TreeDatas {
  constructor(dataSource) {
    this.dataSource = !!dataSource ? dataSource : [{ children: [] }];
    this.id = 'id';
    this.text = 'text';
    this.child = 'children';
    this.expanded = 'state';
    this.parentID = 'parentId';
  }
}
let dataSource = [{ children: [] }];
export default {
  name: 'detailTask',
  components: {},
  data() {
    return {

      fields: new TreeDatas(),
      detail: new Detail(),
      checkedNodes: [],
      indicatorFields: new TreeDatas(),
      checkedIndicator: [],
      isEnodeB:true,
      seatNodes:[],
      indicatorNodes:[]
    };
  },

  watch: {},
  mounted() { },
  computed: {
    checkedNodesToObject() {
      let Obj = {};
      for (let index = 0; index < this.checkedNodes.length; index++) {
        Obj[this.checkedNodes[index]] = this.checkedNodes[index];
      }
      return Obj;
    },
    checkNodeIdsToObject() {
      let Obj = {};
      for (let index = 0; index < this.checkedIndicator.length; index++) {
        Obj[`${this.detail.neTypeId}_${this.detail.neVersionId}_${this.checkedIndicator[index]}`] = `${this.detail.neTypeId}_${this.detail.neVersionId}_${this.checkedIndicator[index]}`;
      }
      return Obj;
    }
  },
  methods: {
    async detailTaskForm(record) {
      // 回填表可靠
      this.detail.sysMeterTimelyTaskName = record.sysMeterTimelyTaskName;
      this.detail.neType = record.neType;
      this.detail.counterType = record.counterType;
      this.detail.alarmCreateTime = record.alarmCreateTime;
      this.detail.sysMeterTimelyCycle = record.sysMeterTimelyCycle;
      this.detail.sysMeterTimelyTimeQuant = this.number2TimeStr(record.sysMeterTimelyTimeQuant);
      this.detail.filesSwitch = this.saveFileRadioCheck(record.filesSwitch);
      this.detail.neVersionId = record.neVersionId;
      this.detail.neTypeId=record.neTypeId;


      /*
      *测量位置
      */
      const _this = this;
      // 查询选中的指标
      await this.$axios
        .get(`/lte/pm/currenttime/taskmanagement/getSeatsByTaskId${commonUtil.analyticParameter({ taskId: record.sysMeterTimelyTaskId })}`, {})
        .then(response => {
          let treeData = response.data.resultVal;
          for (let index in treeData) {
            if(treeData[index].indexOf("_")!=-1){
              _this.isEnodeB=true;
              this.checkedNodes = this.checkedNodes.concat(treeData[index].split('_')[0]);
              this.checkedNodes = this.checkedNodes.concat(treeData[index]);
            }else{
              _this.isEnodeB=false;
              this.checkedNodes = this.checkedNodes.concat(treeData[index].split('_'));
            }

          }
        }).catch(function (error) {
          // 请求失败处理
          console.error('error', error);
        });

      let seatPamars = {};
      seatPamars.systemId = 1;
      seatPamars.counterTypeId = record.counterTypeId;
      seatPamars.neTypeId = record.neTypeId;
      seatPamars.neVersionId = record.neVersionId;

      // 位置树
      await this.$axios
        .post(`/lte/pm/tree/currenttime/seatDetailTree.html${commonUtil.analyticParameter(seatPamars)}`, {})
        .then(response => {
          this.loadingCheckState(response.data);
          _this.fields = new TreeDatas(response.data);

        }).catch(function (error) {
          // 请求失败处理
          console.error('error', error);
        });

      /**测量指标**/
      // 查询选中的指标
      await this.$axios
        .post(`/lte/pm/currenttime/taskmanagement/getCounterIdsByTaskId.html${commonUtil.analyticParameter({ systemId: '1', taskId: record.sysMeterTimelyTaskId })}`, { })
        .then(response => {
          _this.checkedIndicator = response.data.resultVal;

        }).catch(function (error) {
          // 请求失败处理
          console.error('error', error);
        });
      // 指标树
      let indicatorPamars = {};
      indicatorPamars.systemId = 1;
      indicatorPamars.counterTypeId = record.counterTypeId;
      indicatorPamars.counterTypeName = record.sysMeterTimelyTaskName;
      indicatorPamars.neVersionId = record.neVersionId;
      indicatorPamars.neTypeId = record.neTypeId;

      await this.$axios
        .get(`/lte/pm/tree/currenttime/indicatorDetailTree.html${commonUtil.analyticParameter(indicatorPamars)}`, {})
        .then(response => {
          this.indicatorCheckState(response.data)
          _this.indicatorFields = new TreeDatas(response.data);

        }).catch(function (error) {
          // 请求失败处理
          console.error('error', error);
        });

        //把节点置成disabled状态需要延时，等待数据加载完成
        setTimeout(() => {
                _this.setSeatTreeNodeDisabled(this.fields.dataSource);
                _this.$refs.detailSeatTree.disableNodes(this.seatNodes);

                _this.setIndicatorTreeNodeDisabled(this.indicatorFields.dataSource);
                _this.$refs.detailIndicatorTree.disableNodes(this.indicatorNodes);

        }, 300);

        
    },
    loadingCheckState(data) {
      for (let index in data) {
        if(data[index].id=='root'){
          data[index].isChecked = true;
        }

        if (data[index].children && data[index].children.length > 0) {
        if (this.checkedNodesToObject[data[index].id]) {
          data[index].isChecked = true;
          //console.log("hasChildren",data[index]);
        }
          this.loadingCheckState(data[index].children);
        }else{
          if(this.isEnodeB){
            data[index].id=data[index].parentId+"_"+data[index].id;
            //console.log("isEnodeB",this.isEnodeB);
          }
          
          if (this.checkedNodesToObject[data[index].id]) {
             data[index].isChecked = true;
             //console.log("noChildren",data[index]);
          }
        }
      }
    },
    indicatorCheckState(data) {
      for (let index in data) {
        if (this.checkNodeIdsToObject[data[index].id]) {
          data[index].isChecked = true;
        }

        if (data[index].children && data[index].children.length > 0) {
          this.indicatorCheckState(data[index].children);
        }
      }
    },
    /**
 * 秒转时间（00:00:00）
 * @param seconds 秒数
 */
    number2TimeStr(seconds) {
      let timeLength = '';
      const hour = Math.floor(seconds / 3600);
      const minute = Math.floor((seconds % 3600) / 60);
      const second = (seconds % 3600) % 60;
      if (hour < 10) {
        timeLength += `0${hour}:`;
      } else {
        timeLength += `${hour}:`;
      }
      if (minute < 10) {
        timeLength += `0${minute}:`;
      } else {
        timeLength += `${minute}:`;
      }
      if (second < 10) {
        timeLength += `0${second}`;
      } else {
        timeLength += second;
      }
      return timeLength;
    },
    saveFileRadioCheck(filesSwitch) {
      if (filesSwitch == 1) {
        this.$refs.saveFileRadio.click();
        // console.log(this.$refs.saveFileRadio.getSelectedValue());
      }
    },
    setSeatTreeNodeDisabled(data){
      for(let index in data){
        this.seatNodes.push(data[index].id);
        if (data[index].children && data[index].children.length > 0) {
          this.setSeatTreeNodeDisabled(data[index].children);
        }
      }
    },
    setIndicatorTreeNodeDisabled(data){
      for(let index in data){
        this.indicatorNodes.push(data[index].id);
        if (data[index].children && data[index].children.length > 0) {
          this.setIndicatorTreeNodeDisabled(data[index].children);
        }
      }
    }
  }
};
</script>
